import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import { getApplicationsSuccess, applicationsError } from '../actions/applications';

import { GET_APPLICATIONS } from '../constants/action-types/applications';

import { makeSelectIdTkn } from '../selectors/auth';
import clientApi from '../utils/clientApi';

// Utils
function* createHeader(opts = {}) {
  const idToken = yield select(makeSelectIdTkn());
  const options = JSON.parse(JSON.stringify(opts));
  options.headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
  };
  return options;
}

// Workers
export function* getApplications() {
  try {
    const options = yield call(createHeader);
    const res = yield call(clientApi.get, '/applications', options);
    yield put(getApplicationsSuccess(res.data));
  } catch (error) {
    yield put(applicationsError());
  }
}

// Watchers
function* watchGetApplications() {
  yield takeEvery(GET_APPLICATIONS, getApplications);
}

export default function* applicationsSaga() {
  yield all([watchGetApplications()]);
}
